import { theme } from '@theme';
import styled from 'styled-components';
import Tooltip from '../../../shared/tooltip/Tooltip';
import { Typography } from '../../../style/Typography';

const TooltipContent = (retrySent: boolean): JSX.Element => (
  <Typography
    size={theme.typography.h5}
    color={theme.palette.lightGray}
    fontWeight={theme.typography.fontWeights.normal}
  >
    {retrySent
      ? 'This note will be retried on the next push'
      : 'This note could not be pushed and will no longer be automatically retried. Please attempt manually.'}
  </Typography>
);

const RetryTrigger = (
  retrySent: boolean,
  retryButtonDisabled: boolean,
  handleRetry: (addMissingData: boolean) => void,
): JSX.Element => (
  <RetryButton
    disabled={retrySent || retryButtonDisabled}
    data-testid='note-retry-button'
    onClick={() => handleRetry(false)}
  >
    {' '}
    Retry{' '}
  </RetryButton>
);

export const Retry = (
  isVinSolutionNote: boolean,
  retrySent: boolean,
  retryButtonDisabled: boolean,
  handleRetry: (addMissingData: boolean) => void,
): JSX.Element =>
  isVinSolutionNote ? (
    <TooltipWrapper>
      <Tooltip
        trigger={RetryTrigger(retrySent, retryButtonDisabled, handleRetry)}
        data-tooltip-content={TooltipContent(retrySent)}
        cssClass={`retry-tooltip`}
      />
    </TooltipWrapper>
  ) : (
    RetryTrigger(retrySent, retryButtonDisabled, handleRetry)
  );

export const TooltipWrapper = styled.span`
  margin-left: auto;
`;

export const WarningWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 15px;
  padding: 11px 15px;
  margin: 10px 0 10px 0;
  background-color: #fff9dc;
  border: 1px solid #c6beae;
  border-radius: 4px;
  min-width: min-content;
  @media (max-width: 576px) {
    align-items: baseline;
  }
`;

export const RetryButton = styled.button`
  color: ${theme.palette.white};
  border: 1px solid #613b94;
  padding: 5px 11px;
  font-size: 14px;
  border-radius: 4px;
  background-color: #613b94;
  &:hover {
    background-color: #50317a;
  }
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.disabled ? '.65' : '1')};
  line-height: 100%;
`;

export const ButtonsWrapper = styled.div`
  line-height: 100%;
  display: flex;
  gap: 11px;
  margin-left: auto;
  @media (max-width: 576px) {
    display: flex;
    flex-direction: column;
    gap: 11px;
    align-self: baseline;
  }
`;

export const DontCreateButton = styled.button`
  cursor: pointer;
  display: inline-block;
  border: 1px solid ${theme.palette.lightGrayTwo};
  padding: 5px 11px;
  font-size: 14px;
  color: ${theme.palette.lightGrayTwo};
  border-radius: 4px;
  background-color: #613b94;
  opacity: 0.5;
  vertical-align: top;
  white-space: nowrap;
  background-color: unset;
  &:hover {
    opacity: 1;
  }
`;

export const WarningExtended = styled(Typography)`
  align-self: center;

  @media (max-width: 576px) {
    align-self: baseline;
  }
`;

export const RetryButtonWrapper = styled.span`
  margin-left: auto;
`;
